
'use strict';

var $ = require('dibs-jquery-shim');
var SV = require('server-vars');
var tokenReplace = require('dibs-token-replace');
var tracking = require('dibs-tracking');

var methods = {
    updateCounter: function ($pin) {
        if (!$pin || !$pin.length) {
            return false;
        }
        $.ajax({
            url: SV.get('settings.siteProtocol') + '://api.pinterest.com/v1/urls/count.json?callback=?',
            data: {
                url: $pin.data('url')
            },
            success: function (data) {
                if (data.count > 0) {
                    $('#PinCountBubble').html(data.count);
                }
            },
            dataType: 'jsonp'
        });
        return true;
    },

    //Opens a Pin Modal window with image to be pinned and text
    updatePinImage: function (e, src, isModal) {
        var defer = new $.Deferred();
        var $a = e.currentTarget ? $(e.currentTarget) : e;
        var data = $a.data();
        var windowOptions = 'scrollbars=yes,resizable=yes,toolbar=no';
        var top = 0;
        var width = 665;
        var height = 350;
        var winHeight = screen.height;
        var winWidth = screen.width;
        var left = Math.round((winWidth / 2) - (width / 2));
        var win;
        var id;
        var action;
        src = src.indexOf('http') < 0 ? window.location.protocol + src : src;

        if (winHeight > height) {
            top = Math.round((winHeight / 2) - (height / 2));
        }
        win = window.open(
            tokenReplace(
                SV.settings.siteProtocol + '://pinterest.com/pin/create/button/?url={url}&media={media}&description={desc}',
                { url: data.url, media: src, desc: data.title }
            ),
            'pinterest',
            windowOptions + ',height=' + height + ',width=' + width + ',left=' + left + ',top=' + top
        );
        id = setInterval(function () {
            // if applicable, update the counter once the user has pinned and closed the pinterest popup
            if (win && win.closed) {
                clearTimeout(id);
                defer.resolve();
            }
        }, 750);

        action = 'share';
        if (isModal) {
            action += ' - zoom modal';
        }
        this.track(action, data.url, data.title);

        return defer.promise();
    },

    track: function (action, url, target) {
        tracking.trackSocial({
            name: 'pinterest',
            event: action,
            'opt_target': target
        });

        // todo action may have to change to 'product from Item'
        tracking.trackEvent({
            'category': 'share',
            'action': 'product from PDP',
            'label': url
        });
    },
    init: function () {
        var self = this;
        var $pin = $('.js-pinterest-share');
        var $pinBtn = $pin.find('a').first();
        var $pinSub = $pin.find('.sub-nav-list-item').first();
        var $itemHero = $('#itemHero');
        var clickHandler;
        var src;

        this.updateCounter($pinBtn);
        if ($itemHero.length === 0) {
            // generic pinit click for non PDP pages
            clickHandler = function (e) {
                e.preventDefault();
                src = $pinBtn.data('image');
                self.updatePinImage($pinBtn, src).done(function () {
                    // $this should be the pinterest button which should have a data-url attribute
                    self.updateCounter($pinBtn);
                });
            };
            $pinBtn.on('click', clickHandler);
        } else {
            // currently only usable on the PDP page
            clickHandler = function (e) {
                var $container = $itemHero.find('.item-slideshow');
                var $selected = $container.find('.is-selected');
                e.preventDefault();
                if ($selected.length) {
                    src = $selected.find('img').attr('src');
                    self.updatePinImage($pinBtn, src).done(function () {
                        // $this should be the pinterest button which should have a data-url attribute
                        self.updateCounter($pinBtn);
                    });
                }
                return true;
            };
            $pinBtn.on('click', clickHandler);
            $pinSub.on('click', clickHandler);

            $.subscribe('modal:show-hero', function (e, Modal, $overlay) {
                // add a pinterest button to the modal
                var $modal = $overlay.find("#modalOverlay-inner-content");
                // create a separate container since the modal pinterest button does not have the count
                var $pinit = $('<div>').attr('id', 'pinitModal');
                var $a = $pinBtn.clone().appendTo($pinit);
                $pinit.appendTo($modal);
                $a.on('click', function (event) {
                    var $this = $(this);
                    event.preventDefault();
                    // need to fix this to not rely on the .swiper-slide-visible class
                    // something more generic should be used instead
                    src = $overlay.find('.swiper-slide-visible img').attr('src');
                    self.updatePinImage($this, src, true).done(function () {
                        // $this should be the pinterest button which should have a data-url attribute
                        self.updateCounter($this);
                    });
                    return true;
                });
            });
        }
    }
};

module.exports = methods;



//////////////////
// WEBPACK FOOTER
// ./assets/js/social/pinit.js
// module id = 937
// module chunks = 4 7 12 30